import { render, staticRenderFns } from "./Demands.vue?vue&type=template&id=76df83c2&scoped=true"
import script from "./Demands.vue?vue&type=script&lang=js"
export * from "./Demands.vue?vue&type=script&lang=js"
import style0 from "./Demands.vue?vue&type=style&index=0&id=76df83c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df83c2",
  null
  
)

export default component.exports